// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCaseOrderedRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCaseOrderedRelationshipModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCaseOrderedRelationshipModel.discriminator = undefined;
EnrollmentNetStandardCaseOrderedRelationshipModel.additionalProperties = false;
EnrollmentNetStandardCaseOrderedRelationshipModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
];
//# sourceMappingURL=enrollmentNetStandardCaseOrderedRelationshipModel.js.map